import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary } from 'react-error-boundary';
import { ModuleFallbackComponent, moduleLoadingError, } from '../../helpers/ModuleFallbackComponent';
import React, { Suspense } from 'react';
import { makeDefault } from '../../helpers/MakeDefault';
import { FooterSkeleton } from './FooterSkeleton';
const Footer = React.lazy(() => import('fragments/Fragments').then(makeDefault('Footer')));
export const FooterFragment = () => (_jsx(Suspense, { fallback: _jsx(FooterSkeleton, {}), children: _jsx(ErrorBoundary, { FallbackComponent: ModuleFallbackComponent, onError: moduleLoadingError, children: _jsx(Footer, {}) }) }));
